import { useI18n } from '@i18n/useI18n';
import { Col, Container, Grid, GridContainer, StyledArrow } from "./WarningPopup.styled";
import WarningIcon from '@assets/svg/warning.svg'
import { useEffect, useState } from "react";

interface IProps{
    click: (state:boolean) => void;
}

const WarningPopup = (props:IProps) =>{
    const i18n = useI18n()
    const [start, setStart] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setStart(true)
            setTimeout(() => {
                setStart(false)
            }, 16000);
        }, 10);
    }, [])

    return (
        <Container animate={start} onClick={() => props.click(false)}>
            <StyledArrow moveRight={false} size={20} width={12} />
            <GridContainer>
                <Grid>
                    <Col>
                        <WarningIcon />
                    </Col>
                    <Col>
                        <p>{i18n.t("filter-text-custom-warning")}</p>
                    </Col>
                </Grid>
            </GridContainer>
        </Container>
    )
}

export default WarningPopup;